// AutoGenerated
export enum EnmKayitDurum {
    "Yorum Bekleniyor" = 2,
    "Hatalı" = 3,
    "Onay Bekleniyor" = 4,
    "Onaylandı" = 5,
}